import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Dropdown from "~/scripts/components/Dropdown";
import LeftyRighty from "~/scripts/components/LeftyRighty";
import { isMobile } from "../../helpers/is-mobile";

class CaseStudiesFeatured extends Component {
    static propTypes = {
        showFeatured: PropTypes.bool,
        featured: PropTypes.object,
        applications: PropTypes.arrayOf(
            PropTypes.shape({
                slug: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired
            })
        ),
        application: PropTypes.shape({
            id: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired
        }),
        onChange: PropTypes.func
    };

    handleChange = value => {
        const { onChange } = this.props;

        if (onChange) {
            onChange(value);
        }
    }

    render() {
        const {
            showFeatured,
            featured,
            applications,
            application
        } = this.props;

        return (
            <div
                className={classNames("casestudies-featured", {
                    "casestudies-featured--no-featured": !showFeatured
                })}
            >
                {showFeatured && (
                    <div className="casestudies-featured__body">
                        <LeftyRighty
                            direction="left"
                            title={featured.title}
                            subtitle="Featured"
                            text={featured.summary}
                            url={featured.url}
                            imageUrl={featured.imageUrl}
                            button="View case study"
                            desc={[
                                {
                                    label: "Project",
                                    value: featured.project
                                },
                                {
                                    label: "Applications",
                                    value: featured.applications.join(", ")
                                }
                            ]}
                        />
                    </div>
                )}

                <div className="casestudies-featured__head">
                    <div className="casestudies-featured__filter">
                        <Dropdown
                            simple={isMobile}
                            defaultOption={{
                                label: "Any application"
                            }}
                            options={applications.map(application => ({
                                key: application.id,
                                label: application.title,
                                value: application.slug
                            }))}
                            value={
                                application && {
                                    key: application.id,
                                    label: application.title,
                                    value: application.slug
                                }
                            }
                            onChange={this.handleChange}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default CaseStudiesFeatured;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/case-studies/CaseStudiesFeatured.js